export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-16 overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20abstract%20artistic%20background%20with%20deep%20crimson%20red%20and%20charcoal%20black%20tones%2C%20subtle%20grain%20texture%2C%20mysterious%20atmosphere%2C%20dark%20cinematic%20lighting%20with%20soft%20red%20glow%20accents%2C%20no%20text%2C%20no%20people%2C%20abstract%20expressionist%20style%2C%20editorial%20quality&width=1800&height=1200&seq=hero-bg-91hl&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-16 md:py-20 lg:py-24">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/30 text-primary-400 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              实时爆料 · 火热吃瓜
            </span>

            {/* H1 */}
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-50 leading-tight tracking-tight">
              91黑料<span className="text-primary-400">·</span>吃瓜第一站
            </h1>

            {/* Slogan */}
            <p className="mt-3 text-lg md:text-xl text-accent-400 font-heading font-medium">
              黑料吃瓜爆料不停，娱乐围观快人一步
            </p>

            {/* Description */}
            <p className="mt-6 text-sm md:text-base text-foreground-400 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              91黑料吃瓜网汇聚全网最新娱乐八卦与黑料事件，覆盖明星动态、影视综艺、网红圈层等多维度内容。每日滚动更新，确保您不错过任何一条劲爆黑料。无论是91黑料吃瓜在线实时围观，还是黑料吃瓜最新整合盘点，这里都是你的吃瓜黑料网首选阵地。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mt-8">
              {[
                { icon: 'ri-article-line', label: '每日更新', value: '200+' },
                { icon: 'ri-eye-line', label: '在线围观', value: '50w+' },
                { icon: 'ri-chat-3-line', label: '瓜友热议', value: '10w+' },
              ].map((stat) => (
                <div key={stat.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-600/60 hover:border-primary-500/40 text-foreground-300 hover:text-primary-400 font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览专题
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20editorial%20composition%20featuring%20abstract%20shapes%20and%20textures%20in%20deep%20crimson%20red%20against%20a%20dark%20charcoal%20background%2C%20mysterious%20and%20captivating%20atmosphere%2C%20glowing%20warm%20accents%2C%20cinematic%20lighting%2C%20fine%20art%20quality%2C%20no%20text%2C%20no%20people%2C%20elegant%20abstract%20composition&width=960&height=1200&seq=hero-visual-91hl&orientation=portrait"
                alt="91黑料吃瓜网 - 娱乐八卦与黑料事件围观"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
              {/* Decorative badges */}
              <div className="absolute top-4 left-4 px-3 py-1.5 rounded-lg bg-background-950/70 backdrop-blur-sm border border-background-700/50">
                <span className="text-xs text-accent-400 font-medium">🔥 今日热榜</span>
              </div>
              <div className="absolute bottom-4 right-4 px-3 py-1.5 rounded-lg bg-primary-500/80 backdrop-blur-sm">
                <span className="text-xs text-background-950 font-bold">实时更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}